// Page variant from ?v= (the ad decides which art and headline the visitor sees); unknown or missing
// falls back to the brand's default. Variant ids live in brandConfig.variants.
export default function resolveVariant(brandConfig) {
  const requested = new URLSearchParams(window.location.search).get('v')
  const ids = Object.keys(brandConfig.variants || {})
  return ids.includes(requested) ? requested : brandConfig.defaultVariant
}
